<template>
    <div class="languageWidget__list" v-if="storeViewsInfos.length > 1"> 
        <ul>
            
            <li 
                v-for="(store, key) in storeViewsInfos.slice().reverse()" 
                :key="key" 
                class="languageWidget__item"
                :class="store.countryCode === currentStoreView.countryCode ? 'active' : ''"
            >
                <a v-if="store.countryCode != currentStoreView.countryCode " :href="store.storeBaseUrl" >
                    <div class="languageWidget__icon-container">
                        <i class="icon--inline languageWidget__Icon-Flag" :class="'Flag_'+store.countryName"></i>
                    </div>
                    <p>{{ store.countryCode }}</p>
                </a> 

                <div v-else>
                    <div class="languageWidget__icon-container">
                        <i class="languageWidget__Icon-Flag" :class="'Flag_'+store.countryName"></i>
                    </div>
                    <p>{{ store.countryCode }}</p>
                </div>                 
            </li>
            
        </ul>
    </div>    
</template>

<script>
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            baseUrl: process.env.VUE_APP_API_BASE_URL,
        };
    },

    computed: {
        ...mapGetters({ 
            storeViewsInfos: "getStoreViewsInfos",
            currentStoreView: "getCurrentStoreViewsInfos"
        })
    },
    
}
</script>

<style lang="scss" scoped>

.languageWidget__list {
    padding: 22px 28px;

    @media ($mq-desktop) {
        padding: 0;
    }
}

.languageWidget__list ul{
    display: flex;
}

.languageWidget__item {
    text-align: center;
    margin: 0 5px;

    a {
        display: block;
        cursor: pointer;
    }
    p {
        margin: 0;
        transition: all .2s ease-in;
    }
}

// ICON FLAGS
.languageWidget__Icon-Flag.Flag_France {
    background-image: url(../../../../assets/icons/zeborne/Flag_France.svg);
}

.languageWidget__Icon-Flag.Flag_Belgique {
    background-image: url(../../../../assets/icons/zeborne/Flag_Belgique.svg);
}

.languageWidget__icon-container {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    transition: transform .2s ease-in;
    transform-origin: center;
}

.languageWidget__Icon-Flag {
    display: block;
    width: 100%;
    height: 100%;
    background-size: 100%;
    background-repeat: no-repeat;
}

// Is Hovered
.languageWidget__item:not(.active):hover {
    .languageWidget__icon-container {
        transform: scale(.8);
    }

    p {
        font-weight: 700;
    }
}

// Is Active
.languageWidget__item.active { 
    .languageWidget__icon-container {
        padding: 2px;
        border: 2px solid $color-red;
    }

    p {
        font-weight: 700;
        color: $color-red;
    }
}
</style>
